import React from "react";
import styles from "./DeviceTransmissionTable.module.css";

/* Returns e.g. [1, "start-ellipsis", 4, 5, 6, "end-ellipsis", 20] */
const getPageNumbers = (current, total, siblings = 1) => {
    const first = 1;
    const last = total;
    const start = Math.max(first + 1, current - siblings);
    const end = Math.min(last - 1, current + siblings);

    const pages = [first];

    if (start > first + 1) {
        if (start === first + 2) pages.push(first + 1);
        else pages.push("start-ellipsis");
    }

    for (let p = start; p <= end; p++) pages.push(p);

    if (end < last - 1) {
        if (end === last - 2) pages.push(last - 1);
        else pages.push("end-ellipsis");
    }

    if (last > first) pages.push(last);
    return pages;
};

export default function TablePagination({ page, totalPages, totalItems, pageSize, onPageChange, itemLabel = "vehicles" }) {
    if (totalItems === 0) return null;

    const from = (page - 1) * pageSize + 1;
    const to = Math.min(page * pageSize, totalItems);

    return (
        <div className={styles.paginationBar}>
            <div className={styles.paginationInfo}>
                Showing {from}–{to} of {totalItems} {itemLabel}
            </div>

            <div className={styles.paginationControls}>
                <button
                    type="button"
                    className={styles.pageBtn}
                    disabled={page === 1}
                    onClick={() => onPageChange(page - 1)}
                >
                    Prev
                </button>

                {getPageNumbers(page, totalPages).map((p) =>
                    typeof p === "string" ? (
                        <span key={p} className={styles.pageEllipsis}>…</span>
                    ) : (
                        <button
                            key={p}
                            type="button"
                            className={`${styles.pageBtn} ${p === page ? styles.pageBtnActive : ""}`}
                            onClick={() => onPageChange(p)}
                        >
                            {p}
                        </button>
                    )
                )}

                <button
                    type="button"
                    className={styles.pageBtn}
                    disabled={page === totalPages}
                    onClick={() => onPageChange(page + 1)}
                >
                    Next
                </button>
            </div>
        </div>
    );
}
